import {HTTP} from '@/router/http';
import Vue from 'vue'
import moment from 'moment'
const enumerateDaysBetweenDates = function(startDate, endDate) {
	let now = startDate.clone(), dates = [];

	while (now.isSameOrBefore(endDate)) {
		dates.push(now.format('YYYY-MM-DD'));
		now.add(1, 'days');
	}
	return dates;
}

// initial state
const state = {
	vacations: {}
}

// getters
const getters = {
	vacations: state => state.vacations
}

// actions
const actions = {
	getVacations ({ commit, state },params) {
		let dates = enumerateDaysBetweenDates(params.start,params.end)
		let toProcess = _.filter(dates,d => {return state.vacations[d] === undefined});
		if (toProcess.length) {
			HTTP.get('/vacations',{params: {dates: dates.join("$")}}).then(res => {
				commit('SET_VACATIONS', res.data)
			});			
		}
	},
	pushVacation ({ commit },vacation) {
		return new Promise ((resolve,reject) => {
			let method = (isNaN(+vacation.id)) ? "post" : "patch"
			HTTP[method]("vacation",vacation).then(res => {
				if (method === "post") {
					commit("ADD_VACATION",res.data)
				}
				else {
					commit("EDIT_VACATION",res.data)
				}
				resolve(res.data);
			}).catch(err => reject(err))
		})
	},
	deleteVacation ({ commit }, vacation) {
		return HTTP.delete("vacation/"+vacation.vacation_id).then(() => {
			commit("DELETE_VACATION",vacation)
		})
	}
}

// mutations
const mutations = {
	SET_VACATIONS (state, vacations) {
		_.forEach(vacations, (v,date) => {
			Vue.set(state.vacations,date,v)
		})
	},
	ADD_VACATION (state, vacation) {
		let dates = enumerateDaysBetweenDates(moment(vacation.start_date),moment(vacation.end_date))
		_.forEach(dates, d => {
			if (state.vacations[d] !== undefined) {
				let vacs = state.vacations[d]
				let idx = _.findIndex(vacs, v =>  v.user_id === vacation.user_id)
				if (idx === -1) {
					vacs.push(vacation);
					Vue.set(state.vacations,d,vacs)					
				}
			}
		})
	},
	DELETE_VACATION (state, vacation) {
		let dates = enumerateDaysBetweenDates(moment(vacation.start_date),moment(vacation.end_date))
		_.forEach(dates, d => {
			if (state.vacations[d] !== undefined) {
				let vacs = state.vacations[d]
				let idx = _.findIndex(vacs, v =>  v.vacation_id === vacation.vacation_id)
				if (idx > -1) {
					vacs.splice(idx,1);
					Vue.set(state.vacations,d,vacs)					
				}
			}
		})
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}